<template>
  <div style="marginTop:20vh">
    <b-message title="Success" type="is-success" v-if="!user">
      U bent succesvol afgemeld.
    </b-message>
    <b-message title="Fout" type="is-warning" v-else>
      Afmelden mislukt.
    </b-message>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserService from '../../services/userService'

export default {
  computed: {
    ...mapGetters(['user'])
  },

  mounted() {
    this.Logout()
  },

  methods: {
    ...mapActions(['Logout'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth/AuthLogout.vue